import script from "./ModifiedSchiffPitchforkTool.vue?vue&type=script&lang=js"
export * from "./ModifiedSchiffPitchforkTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__